module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-content"
  }, [_c('m-header', [_c('div', {
    attrs: {
      "slot": "nav"
    },
    slot: "nav"
  })]), _vm._v(" "), _c('div', {
    staticClass: "w"
  }, [_c('div', {
    staticClass: "item-info gray-box"
  }, [(_vm.itemTitle) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("\n        " + _vm._s(_vm.itemTitle) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.itemTime) ? _c('div', {
    staticClass: "item-time"
  }, [_vm._v("\n        " + _vm._s(_vm.itemTime) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.itemDetail) ? _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.itemDetail)
    }
  }, [_vm._v(_vm._s(_vm.itemDetail))])]) : _c('div', {
    staticClass: "no-info"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/no-data.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          暂无内容数据\n        ")])])])]), _vm._v(" "), _c('m-footer'), _vm._v(" "), _c('Customer', {
    staticClass: "customerSer"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c72a8c8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/School/schoolDetail.vue
// module id = 661
// module chunks = 0